import React from "react";

const ColorDisplay = ({ pickedColor, setDisplayColorSelector }) => {
  const hexColor = pickedColor.hex();
  const textColor = pickedColor.isLight() ? "black" : "white";

  return (
    <div
      className="color-row-display"
      style={{ backgroundColor: hexColor }}
      onClick={() => setDisplayColorSelector(true)}>
      <p className="text" style={{ color: textColor }}>
        {hexColor}
      </p>
    </div>
  );
};

export default ColorDisplay;
